function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { login as _login, logout as _logout, getInfo as _getInfo } from '@/api/user';
import { getToken, setToken as _setToken, removeToken } from '@/utils/auth';
import router, { resetRouter } from '@/router';
import Cookies from 'js-cookie';
import { Loading } from 'element-ui';
var state = {
  token: getToken(),
  name: '',
  avatar: '',
  introduction: '',
  roles: [],
  permissions: [],
  captcha: {
    captchaVerification: '',
    secretKey: '',
    token: ''
  },
  //滑块验证token
  controlDeliverySwitch: false,
  // 平台配送开关
  isDelivery: false // 商户配送开关
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
    state.introduction = introduction;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_PERMISSIONS: function SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions;
  },
  SET_CAPTCHA: function SET_CAPTCHA(state, captcha) {
    state.captcha = captcha;
  },
  SET_CONTROL_DELIVERY_SWITCH: function SET_CONTROL_DELIVERY_SWITCH(state, controlDeliverySwitch) {
    state.controlDeliverySwitch = controlDeliverySwitch;
  },
  SET_IS_DELIVERY: function SET_IS_DELIVERY(state, isDelivery) {
    state.isDelivery = isDelivery;
  }
};
var actions = {
  // user login
  login: function login(_ref, userInfo) {
    var commit = _ref.commit;
    var account = userInfo.account,
      pwd = userInfo.pwd,
      key = userInfo.key,
      code = userInfo.code,
      wxCode = userInfo.wxCode;
    Loading.service();
    return new Promise(function (resolve, reject) {
      _login(userInfo).then(function (data) {
        var loadingInstance = Loading.service();
        loadingInstance.close();
        window.localStorage.clear();
        commit('SET_TOKEN', data.token);
        Cookies.set('JavaMerInfo', JSON.stringify(data));
        _setToken(data.token);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // get user info
  getInfo: function getInfo(_ref2) {
    var commit = _ref2.commit,
      state = _ref2.state;
    return new Promise(function (resolve, reject) {
      _getInfo(state.token).then(function (data) {
        if (!data) {
          reject('Verification failed, please Login again.');
        }
        var roles = data.roles,
          account = data.account;
        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject('getInfo: roles must be a non-null array!');
        }
        console.log('获取商户信息====', data);
        commit('SET_ROLES', roles);
        // commit('SET_ROLES', ['admin'])
        commit('SET_NAME', account);
        // commit('SET_AVATAR', avatar)
        commit('SET_AVATAR', 'http://kaifa.crmeb.net/system/images/admin_logo.png');
        commit('SET_INTRODUCTION', 'admin');
        commit('SET_PERMISSIONS', data.permissionsList); //权限标识
        commit('SET_CONTROL_DELIVERY_SWITCH', data.controlDeliverySwitch); // 平台配送开关
        commit('SET_IS_DELIVERY', data.isDelivery); // 商户配送开关
        Cookies.set('merStarLevel', data.merStarLevel);
        Cookies.set('mreId_data', data.id);
        localStorage.setItem('mreId', data.id);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // user logout
  logout: function logout(_ref3) {
    var commit = _ref3.commit,
      state = _ref3.state,
      dispatch = _ref3.dispatch;
    Loading.service();
    return new Promise(function (resolve, reject) {
      _logout(state.token).then(function () {
        var loadingInstance = Loading.service();
        loadingInstance.close();
        commit('SET_TOKEN', '');
        commit('SET_ROLES', []);
        commit('SET_PERMISSIONS', []);
        removeToken();
        resetRouter();
        //
        Cookies.remove('storeStaffList');
        Cookies.remove('JavaMerInfo');
        sessionStorage.removeItem('token');
        // reset visited views and cached views
        // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
        dispatch('tagsView/delAllViews', null, {
          root: true
        });
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref4) {
    var commit = _ref4.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      removeToken();
      resolve();
    });
  },
  // 设置token
  setToken: function setToken(_ref5, state) {
    var commit = _ref5.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', state.token);
      Cookies.set('JavaMerInfo', JSON.stringify(state));
      _setToken(data.token);
      resolve();
    });
  },
  // dynamically modify permissions
  changeRoles: function changeRoles(_ref6, role) {
    var commit = _ref6.commit,
      dispatch = _ref6.dispatch;
    return new Promise(/*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(resolve) {
        var token, _yield$dispatch, roles, accessRoutes;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              token = role + '-token';
              commit('SET_TOKEN', token);
              _setToken(token);
              _context.n = 1;
              return dispatch('getInfo');
            case 1:
              _yield$dispatch = _context.v;
              roles = _yield$dispatch.roles;
              resetRouter();

              // generate accessible routes map based on roles
              _context.n = 2;
              return dispatch('permission/generateRoutes', roles, {
                root: true
              });
            case 2:
              accessRoutes = _context.v;
              // dynamically add accessible routes
              router.addRoutes(accessRoutes);

              // reset visited views and cached views
              dispatch('tagsView/delAllViews', null, {
                root: true
              });
              resolve();
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref7.apply(this, arguments);
      };
    }());
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};